<template>
  <div class="dashboard__dashboardrequestlist">
    <div class="dashboard__dashboardrequestlist--header">
      <h1>On-Going Shipment</h1>
      <router-link :to="{ name: 'ManagementShipment', params: { type: 'ongoing' }}">See All</router-link>
    </div>
    <div class="dashboard__dashboardrequestlist--contentlist" v-if="shipment">
      <router-link 
        class="dashboard__dashboardrequestlist--content"
        v-for="(items) in shipment.results"
        :key="items.orderNumber"
        style="border-bottom: 1px solid #E8EBEE"
        :to="{ 
          name: 'ManagementShipmentDetail', 
          params: { 
            type: 'ongoing', 
            id_shipment: items.shipmentId, 
            order_number: items.orderNumber.replaceAll('/', '-') 
            }
          }"
      >
        <div class="dashboard__dashboardrequestlist--contentleft">
          <img :src="getImageShipment(items.freightMode)" alt="" width="32" height="32">
          <div class="dashboard__dashboardrequestlist--shipmentdetails">
            <h2 v-if="items.freightMode === 'LAND'">{{ items.originCity }} ({{ items.originCityCode }}) to {{ items.destinationCity }} ({{ items.destinationCityCode }})</h2>
            <h2 v-else>{{ items.originCity }} ({{ items.originCountryCode }}) to {{ items.destinationCity }} ({{ items.destinationCountryCode }})</h2>
            <p>{{ items.referenceNumber }} | {{ items.freightMode === 'LAND' ? formatShipmentType(items.freightMode) : formatShipmentType(items.freightType) }}</p>
          </div>
        </div>
        <span 
          class="dashboard__dashboardrequestlist--status"
          :style="items.freightMode === 'LAND' ? 
            'background-color: #285231' : 
            items.freightMode === 'AIR' ? 
              'background-color: #673C86' : 
              'background-color: #1D3354'"
        ><p>{{ 
          items.orderStat === 'DESTINATION_LOCAL_HANDLING' 
            ? 'Destination Local Handling' 
            : items.orderStat === 'ORIGIN_LOCAL_HANDLING' 
              ? 'Origin Local Handling' 
              : items.orderStat 
            }}
          </p>
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OngoingShipment',
  data () {
    return {
      list: [
        { row1: 'Jakarta (IDN) to Hamburg (DEU)', row2: 'RFQ/2023062800001673 | FCL' },
        { row1: 'Kota b', row2: 'test' },
        { row1: 'Kota c', row2: 'test' },
        { row1: 'Kota d', row2: 'test' },
        { row1: 'Kota e', row2: 'test' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      shipment: 'shipment/items',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error'
    })
  },
  mounted () {
    this.fetchOngoingShipment()
  },
  methods: {
    getImageShipment (type) {
      if (type === 'OCEAN') {
        return require('@/assets/image/icon/shipment-ocean-color.svg')
      } else if (type === 'LAND') {
        return require('@/assets/image/icon/shipment-land-color.svg')
      }
      return require('@/assets/image/icon/shipment-air-color.svg')
    },

    async fetchOngoingShipment () {
      await this.$store.dispatch('shipment/FETCH_SHIPMENT_LIST', {
        type: 'ongoing', currentPage: 1, perPage: 5
      })
    },

    formatShipmentType (data) {
      const upperCaseData = data.toUpperCase()
      if (upperCaseData === 'AIRCOURIER') {
        return 'Air Courier'
      } else if (upperCaseData === 'AIRCARGO') {
        return 'Air Cargo'
      } else if (upperCaseData === 'AIRBREAKBULK') {
        return 'Air Breakbulk'
      } else if (upperCaseData.includes('FCL') || upperCaseData.includes('LCL')) {
        return upperCaseData.substring(3)
      } else if (upperCaseData === 'OCEANBREAKBULK' || upperCaseData === 'SEABREAKBULK') {
        return 'Ocean Breakbulk'
      } else if (upperCaseData === 'LAND') {
        return 'Land'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/OngoingShipment.vue